import { DateRange } from './../../../interfaces/dateRange';
import { ProjectService } from './../../../services/project.service';
import { Project, ProjectStatsConfiguration } from './../../../interfaces/project';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BbTableService } from '../../../services/bb-table.service';
import { KPICalculation } from '../../../services/project-kpi.service';
import { Datafeed } from '../../../interfaces/datafeed';
import { SapiService } from '../../../services/sapi.service';

@Component({
	selector: 'library-project-details-analysis',
	templateUrl: './library-project-details-analysis.component.html',
	styleUrls: ['./library-project-details-analysis.component.scss'],
	providers: [
		BbTableService
	]
})

export class LibraryProjectDetailsAnalysisComponent implements OnInit {

	@Input() project: Project;
	@Input() form: NgForm;

	justAddedIndex: number;
	configuration: ProjectStatsConfiguration;
	dateColumnOptions: any = {};
	datafeedVars: any = {};
	dateRange: any;
	kpiId: any;

	constructor(
		private projectService: ProjectService,
		private sapiService: SapiService
	) { }

	ngOnInit() {
		if (history.state.dateRange) {
			this.dateRange = history.state.dateRange;
			this.kpiId = history.state.kpiId;
		}

		if (!this.project) {
			return;
		}

		if (!this.project.kpiCalculations) {
			this.project.kpiCalculations = [];
			return;
		}

		this.project.kpiCalculations.forEach((kpi: KPICalculation) => {
			if (kpi.externalDataId) {
				this.getDatafeedForKpi(kpi.externalDataId, kpi);
			}
		});
	}

	datesChanged(dateRange: DateRange) {
		this.configuration = {};
		this.configuration.statsDateStart = dateRange.startDate;
		this.configuration.statsDateEnd = dateRange.endDate;
		// load this.project.kpiCalculations (the goal and formula)
		this.projectService.getProjectStats(dateRange, this.project.id).subscribe();
	}

	addKPI(kpi?: KPICalculation) {
		if (!this.project || !this.project.kpiCalculations) {
			this.project.kpiCalculations = [];
		}

		this.project.kpiCalculations.push({
			label: '',
			description: '',
			parts: [],
			isPercentage: true,
			isMonthly: false,
			id: this.generateId()
		});

		this.justAddedIndex = this.project.kpiCalculations.length - 1;
		this.form.form.markAsDirty();
	}

	removeKPI(index: number) {
		this.project.kpiCalculations.splice(index, 1);
		this.form.form.markAsDirty();
	}

	duplicateKPI(index: number) {
		const copy = JSON.parse(JSON.stringify(this.project.kpiCalculations[index]));
		copy.id = this.generateId();
		copy.label += ' copy';
		this.project.kpiCalculations.push(copy);
		this.getDatafeedForKpi(copy.externalDataId, copy);

		this.form.form.markAsDirty();
	}

	moveToIndex(fromIndex: number, toIndex: number) {
		const itemToMove = this.project.kpiCalculations.splice(fromIndex, 1)[0];
		this.project.kpiCalculations.splice(toIndex, 0, itemToMove);
		this.form.form.markAsDirty();
	}

	generateId() {
		return 'k' + Math.random().toString(36).substr(2, 16);
	}


	onKpiTypeClick(kpiType: string, kpi: any) {
		switch (kpiType) {
			case 'percentage':
				kpi.isPercentage = true;
				kpi.isMonthly = false;
				kpi.isTime = false;
				break;
			case 'monthly':
				kpi.isPercentage = false;
				kpi.isMonthly = true;
				kpi.isTime = false;
				break;
			case 'time':
				kpi.isPercentage = false;
				kpi.isMonthly = false;
				kpi.isTime = true;
				break;
			case 'total':
			default:
				kpi.isPercentage = false;
				kpi.isMonthly = false;
				kpi.isTime = false;
				break;
		}
	}

	onFeedSelected(datafeedId: string, kpi: KPICalculation) {
		if (datafeedId) {
			kpi.dateColumn = null;
			kpi.externalDataType = 'Datafeed';
			this.getDatafeedForKpi(datafeedId, kpi);
		}
	}

	onDateColumnSelected(dateColumn: string, kpi: KPICalculation) {
		if (dateColumn) {
			this.getDatafeedVars(dateColumn, kpi.id);
		}
	}

	getDatafeedForKpi(datafeedId: string, kpi: KPICalculation) {
		this.sapiService.get('datafeed', datafeedId).subscribe((datafeed: Datafeed) => {

			this.dateColumnOptions[kpi.id] = datafeed.columns.map((column: any) => ({
				value: column.key,
				label: column.label
			}));

			if (kpi.dateColumn) {
				this.getDatafeedVars(kpi.dateColumn, kpi.id);
			}
		});

	}

	getDatafeedVars(dateColumn: string, kpiId: string) {
		this.datafeedVars[kpiId] = this.dateColumnOptions[kpiId].filter((column: any) => column.value !== dateColumn).map((column: any) => ({
			type: 'variable',
			entity: 'external',
			property: column.value,
			label: column.label,
			icon: 'table'
		}));
	}
}
